const defaultFields = () => ({
	name: null,
	description: null,
})

export {
	defaultFields
}
